import axios from 'axios';
import API_URL from '../config';
import { getAuthToken } from './authSession';

// Opent de schoonmaakinstructies-PDF in een nieuw tabblad. Het tabblad wordt
// meteen bij de klik geopend (anders blokkeert de browser het) en daarna naar
// een korte, ondertekende PDF-link gestuurd.
export async function openCleaningPdf(propertyId) {
  const win = window.open('', '_blank');
  try {
    const res = await axios.post(`${API_URL}/api/properties/${propertyId}/cleaning-pdf-link`, {}, {
      headers: { Authorization: `Bearer ${getAuthToken()}` }
    });
    const url = `${API_URL}${res.data.url}`;
    if (win) win.location.href = url;
    else window.open(url, '_blank');
  } catch (e) {
    if (win) win.close();
    throw e;
  }
}
